import {ApplicationRef, Component, EventEmitter, Input, OnInit, Output, Renderer2} from "@angular/core";
import {ControlContainer, NgForm} from "@angular/forms";
import {TunapayService} from "../../services/tunapay.service";

import {FormaDePagamento} from "../../objeto/FormaDePagamento";
import {TunapayScript} from "./tunapay.script";
import {MyDetectorDevice} from "../../app/shared/MyDetectorDevice";
import {TunapayGlobalComponent} from "../tunapay-global.component";



@Component({
  selector: 'app-tunnapay-digitais',
  templateUrl: './tunapay-carteirasdigitais.component.html',
  styleUrls: ['./tunapay-carteirasdigitais.component.scss'],
  viewProviders: [ { provide: ControlContainer, useExisting: NgForm } ]
})

export class TunapayCarteirasDigitaisComponent extends TunapayScript implements   OnInit {
  @Input() formaDePagamento: any = {};
  @Input() pedido: any = {};
  @Output() definiuCartao = new EventEmitter();
  @Output() escolheuFormaPagamento = new EventEmitter();
  @Output() redirecionarParaCarteirasDigitais = new EventEmitter(); // NOVO

  processando = false;

  msgErro: string;
  timerAbaAberta: any;
  isMobile: boolean;
  googlePayDisponivel = false;
  applePayDisponivel = false;
  formaPagamentoGooglePay: any;
  formaPagamentoApplePay: any;
  urlRedirect: string
  constructor(protected tunapayService: TunapayService, protected app: ApplicationRef,
              protected renderer: Renderer2,   private detectorDevice: MyDetectorDevice) {
    super(tunapayService, app, renderer)
    this.formaPagamentoGooglePay = new FormaDePagamento()
    this.formaPagamentoApplePay = new FormaDePagamento();
    this.isMobile = this.detectorDevice.isMobile();
  }

  ngOnInit(): void {
    Object.assign(this.formaPagamentoGooglePay, this.formaDePagamento)
    this.formaPagamentoGooglePay.carteiraDigital = 'GooglePay';

    Object.assign(this.formaPagamentoApplePay, this.formaDePagamento)
    this.formaPagamentoApplePay.carteiraDigital = 'ApplePay';

    //ja esta selecionado
    if(this.pedido.pagamento.formaDePagamento){
      if(this.pedido.pagamento.formaDePagamento.carteiraDigital === 'GooglePay')
        this.formaPagamentoGooglePay =  this.pedido.pagamento.formaDePagamento
      if(this.pedido.pagamento.formaDePagamento.carteiraDigital === 'ApplePay')
        this.formaPagamentoApplePay =  this.pedido.pagamento.formaDePagamento
    }

    this.inicializeTuna(this.pedido.guid).then((err) => {
       if(!err){
         // Configura Google Pay após inicializar Tuna
         this.configureGooglePay();
         this.configureApplePay();
       }
    });

    this.tunapayService.obtenhaUrlRedirect(this.pedido.guid).then((url) => {
      this.urlRedirect = url;
    })
  }

  private configureGooglePay() {
    const merchantInfo = {
      merchantId: 'BCR2DN6TR7QYLIKK'
    };

    const transactionInfo = {
      transactionId: new Date().getTime(),
      totalPriceStatus: 'FINAL',
      totalPrice: 1,
      currencyCode: "BRL",
      countryCode: "BR"
    };

    // Callback quando o pagamento for concluído
    const checkoutCallback = async (response: any) => {

    };

    // Configura o Google Pay usando a API do Tuna
    this.tunaInstance.useGooglePay(
      '#google-pay-container', // ID do container do botão
      merchantInfo,
      checkoutCallback,
      null,
      transactionInfo
    )

    this.googlePayDisponivel = true;

  }

  private configureApplePay() {
    const applePaySettings = {
      buttom: {
        selector: '#applePayDiv',
        style: {
          buttonStyle: "black",
          type: "check-out",
          locale: "pt-BR",
          width: "10px",
          height: "10px",
          borderRadius: "10px",
          padding: "10px",
          boxSizing: "10px"
        }
      },
      applePayCallback: async (applePayPayload: any) => { },
      cart: {
        lineItems: [{
          label: "Pedido",
          amount: (this.pedido.obtenhaValorAhPagar()).toFixed(2)
        }],
        total: {
          label: "Total do Carrinho",
          amount: {value: (this.pedido.obtenhaValorAhPagar()).toFixed(2), currency: "BRL"}
        }
      },
      merchantId: 'merchant.uy.tunahmlg',
      displayName: 'fibo.meucardapio',
    };

    console.log(applePaySettings)

    this.tunaInstance.useApplePay(applePaySettings)
      .then((flag, err) => {
        console.log('Apple Pay  run: ' + flag);
        this.applePayDisponivel = flag;
        this.app.tick();
      })
      .catch((err: any) => {
        console.error('Erro detalhado ao configurar Apple Pay:', err);
        this.applePayDisponivel = false;
        this.app.tick();
      });
  }

  escolheuPagamentoApplePay() {
    if (this.applePayDisponivel) {
      this.pedido.calculeTotal();
      this.prepararRedirecionamento('ApplePay');
    }
  }

  escolheuPagamentoGoogle() {
    this.pedido.calculeTotal();

    if(this.googlePayDisponivel)
        this.prepararRedirecionamento('GooglePay');

  }

  private prepararRedirecionamento(carteira: string) {
    // pega largura e altura da tela
    let erro = TunapayGlobalComponent.abraModalPagamentoExterno(this.urlRedirect, carteira,
      this.isMobile, false, (result: any ) => {

      if(result.fechou || result.fechou){
        this.pedido.pagamento.processando = false;
        //  clearInterval(this.timerAbaAberta);
        this.tunapayService.obtenhaDadosTemporarios(this.pedido.guid).then( (resp: any) => {
          if(resp.cartao){
            for(let key of Object.keys(resp.cartao))
              this.cartao[key]  = resp.cartao[key]
            console.log(this.cartao)
            this.definiuCartao.emit(this.cartao)
          }
          this.processando = false;
        }).catch((err2: any) => {
          this.msgErro = err2
          this.processando = false;
        })
      }
    } );

    if(!erro){
      this.processando = true;
      this.pedido.pagamento.processando = true;
      this.salveDadosPedidoTemporario(carteira);
    } else {
      this.processando = false;
      this.msgErro = erro
    }
  }

  private   salveDadosPedidoTemporario(carteiraDigital: string ){
    const dadosPedido = {
      sessionId: this.tunaInstance.sessionID,
      env: this.tunaInstance.env,
      guid: this.pedido.guid,
      valorPagamento: this.pedido.obtenhaValorAhPagar(),
      formaDePagamento: carteiraDigital === 'GooglePay' ?
        this.formaPagamentoGooglePay.id : this.formaPagamentoApplePay.id,
      carteiraDigital: carteiraDigital,
      parentOrigin:  window.location.origin,
    };

    this.tunapayService.salveDadosTemporarios(dadosPedido).then( () => {  })

  }
}
